import { render, staticRenderFns } from "./NoLoOlvidesPolicy.vue?vue&type=template&id=ad0062a4&scoped=true&"
import script from "./NoLoOlvidesPolicy.vue?vue&type=script&lang=js&"
export * from "./NoLoOlvidesPolicy.vue?vue&type=script&lang=js&"
import style0 from "./NoLoOlvidesPolicy.vue?vue&type=style&index=0&id=ad0062a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0062a4",
  null
  
)

export default component.exports